import React from 'react';
import { Redirect } from 'react-router-dom';
import paths from '../../_helpers/paths';
import useUser from '../LoginPage/useUser';
import { ROLES } from '../../_helpers/Constants';

export default function HomePage() {
  const user = useUser();
  const roles = user?.roles || [];
  const onlyFincenter = roles.length === 1 && roles[0] === ROLES.ES_FINCENTER;

  if (onlyFincenter) {
    return <Redirect to={paths.reportsFincenterTabSigned} />;
  }

  return <Redirect to={paths.contingentReportDDOPage} />;
}
